import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCrystalComponent } from './simple-icons-crystal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCrystalComponent ],
    exports:      [ SimpleIconsCrystalComponent ],
    bootstrap:    []
})
export class SimpleIconsCrystalModule {}
